import React from "react";
import axios from 'axios';
import { Box } from "./ContactFormStyles";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL;

const ContactForm = () => {
  const [formStatus, setFormStatus] = React.useState('Send')
  const [captchaToken, setCaptchaToken] = React.useState(null)
  const recaptchaRef = React.useRef(null)

  function onChange(value) {
    setCaptchaToken(value)
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    if (!captchaToken) {
      setFormStatus('Please complete the reCAPTCHA')
      return
    }

    const { name, email, message } = e.target.elements
    setFormStatus('Submitting...')

    try {
      await axios.post(CONTACT_API_URL, {
        name: name.value,
        email: email.value,
        message: message.value,
        token: captchaToken,
      })
      setFormStatus('Submitted')
      name.value = ''
      email.value = ''
      message.value = ''
      setCaptchaToken(null)
      if (recaptchaRef.current) {
        recaptchaRef.current.reset()
      }
    } catch (err) {
      console.error('Contact form submission failed:', err)
      setFormStatus('Something went wrong. Please try again.')
    }
  }
  return (
    <Box>
      <div className="container mt-5">
        <h2 className="mb-3" >Online Enquiry</h2>
        <form
          onSubmit={onSubmit}

        >
          <div className="mb-3">
            <label className="form-label" htmlFor="name">
              Name
            </label>
            <input className="form-control" type="text" id="name" required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input className="form-control" type="email" id="email" required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="message">
              Message
            </label>
            <textarea className="form-control" id="message" required />
          </div>
          <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onChange} theme="dark" style={{ width: "100%" }} />
          <br />
          <button className="btn btn-success" type="submit" style={{ width: "100%", backgroundColor: "#8B0000", borderColor: "#8B0000" }}>
            {formStatus}
          </button>
        </form>
      </div>
    </Box>
  )
}
export default ContactForm
